export default "__VITE_ASSET__D82GnIlm__"